import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RoleForm } from '@/features/security/role-form';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/roles/new')({ component: NewRoleRoute });

function NewRoleRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="roles"
      crumbs={[{ label: t('security.roles.title') }, { label: t('security.roles.newTitle') }]}
    >
      <RoleForm tenantId={tenant} />
    </ConsoleShell>
  );
}
